'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotIsosurface3dIcon = function PlotIsosurface3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M30.313 18.375l-2.375-2.188-4.438-11.5 1.063-1.375 4.063 7.563zm-12.5 5.188l-10.25-7L11.001 5h11.875l4.375 11.25zM24 2.938l-1.063 1.375H10.812l-3-1.625 7.75-.938zm-17.125 0l3.438 1.875-3.375 11.688-5.313 2.875v-7.813zM1.75 20.063l5.438-2.938 10.313 7-.938 6.125-9.313-2.563zm22.75 7l-7.25 3.063.875-5.938 9.5-7.375 2.75 2.563z' })
    );
};

exports.default = PlotIsosurface3dIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotIsosurface3dIcon.js
// module id = 666
// module chunks = 0